export const QUESTION_MAX_NAME_LENGTH = 85;
export const QUESTION_MIN_NAME_LENGTH = 1;
